// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tip-left {
   top: 10px;
   left: -22px;
   border: 11px solid transparent;
   border-right-color: #2ab4c0;
   position: absolute;
   content: '';

}

.comment-deactive {
   display: block;
   position: absolute;
   width: 100%;
   height: auto;
   padding: 10px;
   background-color: #ffffff;
   border-radius: 3px;
   border: 1px solid #ccc;
}
.comment-active {
   display: block;
   position: absolute;
   width: 100%;
   height: auto;
   padding: 10px;
   background-color: #ffffff;
   border-radius: 3px;
   border: 1px solid #2ab4c0;
   left: -20px;
   z-index: 999;
}

.more-reply {
   padding-left: 48px;
   padding-top: 5px;
   color: #2ab4c0;
}

.content-preview {
   max-height: 40px;
   overflow: hidden;
}

.reply-container {
   max-height: 150px;
   overflow: auto;
}

.comments-container {
   overflow: auto;
}

.comments-container ul {
   list-style: none;
   margin: 0;
   padding: 0;
}

.comments-container li {
   margin-top: 0;
}


.comment-item {
   line-height: 20px;
   margin-left: 48px;
   position: relative;
}

.comment-item a {
   cursor: pointer;
}

.comment-item .avatar {
   float: left;
   margin-left: -48px;
   margin-top: 3px;
   width: 36px;
   height: 36px;
   border-radius: 50%;
}

.comment-item .time {
   color: #657786;
   font-size: 12px;
}

.comment-item .delete {
   color: #999;
   cursor: pointer;
   position: absolute;
   top: 0;
   right: 0;
   font-size: 20px;
   width: 20px;
   height: 20px;
   display: none;
}

.comment-item:hover .delete {
   display: block;
}

.comment-item .delete:hover {
   color: #d32f2f;
}

.word-break {
   word-break: break-all;
   white-space: pre-line;
}

.editing .item-content, .textarea-content {
   display: none;
}

.editing .textarea-content {
   display: block;
}

.textarea-content {
   margin-top: 5px;
}

.delete2 {
   color: #999;
   vertical-align: middle;
   font-size: 16px;
   text-align: center;
   cursor: pointer;
}

.delete2:hover {
   color: #d32f2f;
}

.comment-add {
   text-align: right;
}

.comment-add textarea {
   display: block;
   width: 100%;
   margin-top: 10px;
}

.comment-line {
   margin-top: 10px;
   margin-bottom: 10px;
}

.comment-line-end {
   margin-top: 10px;
}

.comment-add button {
   margin-top: 10px;
   padding: 1px 16px;
   line-height: initial;
   min-width: 64px;
}
@media (min-width: 768px) {
   .is-desktop .comments-panel .comments-thread-container.active {
      left: -36px;
   }
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/comment-pdf/comments/comments.component.css"],"names":[],"mappings":"AAAA;GACG,SAAS;GACT,WAAW;GACX,8BAA8B;GAC9B,2BAA2B;GAC3B,kBAAkB;GAClB,WAAW;;AAEd;;AAEA;GACG,cAAc;GACd,kBAAkB;GAClB,WAAW;GACX,YAAY;GACZ,aAAa;GACb,yBAAyB;GACzB,kBAAkB;GAClB,sBAAsB;AACzB;AACA;GACG,cAAc;GACd,kBAAkB;GAClB,WAAW;GACX,YAAY;GACZ,aAAa;GACb,yBAAyB;GACzB,kBAAkB;GAClB,yBAAyB;GACzB,WAAW;GACX,YAAY;AACf;;AAEA;GACG,kBAAkB;GAClB,gBAAgB;GAChB,cAAc;AACjB;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA;GACG,iBAAiB;GACjB,cAAc;AACjB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,gBAAgB;GAChB,SAAS;GACT,UAAU;AACb;;AAEA;GACG,aAAa;AAChB;;;AAGA;GACG,iBAAiB;GACjB,iBAAiB;GACjB,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,kBAAkB;GAClB,eAAe;GACf,WAAW;GACX,YAAY;GACZ,kBAAkB;AACrB;;AAEA;GACG,cAAc;GACd,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,eAAe;GACf,kBAAkB;GAClB,MAAM;GACN,QAAQ;GACR,eAAe;GACf,WAAW;GACX,YAAY;GACZ,aAAa;AAChB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,qBAAqB;GACrB,qBAAqB;AACxB;;AAEA;GACG,aAAa;AAChB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,WAAW;GACX,sBAAsB;GACtB,eAAe;GACf,kBAAkB;GAClB,eAAe;AAClB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,cAAc;GACd,WAAW;GACX,gBAAgB;AACnB;;AAEA;GACG,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,gBAAgB;GAChB,iBAAiB;GACjB,oBAAoB;GACpB,eAAe;AAClB;AACA;GACG;MACG,WAAW;GACd;AACH","sourcesContent":[".tip-left {\n   top: 10px;\n   left: -22px;\n   border: 11px solid transparent;\n   border-right-color: #2ab4c0;\n   position: absolute;\n   content: '';\n\n}\n\n.comment-deactive {\n   display: block;\n   position: absolute;\n   width: 100%;\n   height: auto;\n   padding: 10px;\n   background-color: #ffffff;\n   border-radius: 3px;\n   border: 1px solid #ccc;\n}\n.comment-active {\n   display: block;\n   position: absolute;\n   width: 100%;\n   height: auto;\n   padding: 10px;\n   background-color: #ffffff;\n   border-radius: 3px;\n   border: 1px solid #2ab4c0;\n   left: -20px;\n   z-index: 999;\n}\n\n.more-reply {\n   padding-left: 48px;\n   padding-top: 5px;\n   color: #2ab4c0;\n}\n\n.content-preview {\n   max-height: 40px;\n   overflow: hidden;\n}\n\n.reply-container {\n   max-height: 150px;\n   overflow: auto;\n}\n\n.comments-container {\n   overflow: auto;\n}\n\n.comments-container ul {\n   list-style: none;\n   margin: 0;\n   padding: 0;\n}\n\n.comments-container li {\n   margin-top: 0;\n}\n\n\n.comment-item {\n   line-height: 20px;\n   margin-left: 48px;\n   position: relative;\n}\n\n.comment-item a {\n   cursor: pointer;\n}\n\n.comment-item .avatar {\n   float: left;\n   margin-left: -48px;\n   margin-top: 3px;\n   width: 36px;\n   height: 36px;\n   border-radius: 50%;\n}\n\n.comment-item .time {\n   color: #657786;\n   font-size: 12px;\n}\n\n.comment-item .delete {\n   color: #999;\n   cursor: pointer;\n   position: absolute;\n   top: 0;\n   right: 0;\n   font-size: 20px;\n   width: 20px;\n   height: 20px;\n   display: none;\n}\n\n.comment-item:hover .delete {\n   display: block;\n}\n\n.comment-item .delete:hover {\n   color: #d32f2f;\n}\n\n.word-break {\n   word-break: break-all;\n   white-space: pre-line;\n}\n\n.editing .item-content, .textarea-content {\n   display: none;\n}\n\n.editing .textarea-content {\n   display: block;\n}\n\n.textarea-content {\n   margin-top: 5px;\n}\n\n.delete2 {\n   color: #999;\n   vertical-align: middle;\n   font-size: 16px;\n   text-align: center;\n   cursor: pointer;\n}\n\n.delete2:hover {\n   color: #d32f2f;\n}\n\n.comment-add {\n   text-align: right;\n}\n\n.comment-add textarea {\n   display: block;\n   width: 100%;\n   margin-top: 10px;\n}\n\n.comment-line {\n   margin-top: 10px;\n   margin-bottom: 10px;\n}\n\n.comment-line-end {\n   margin-top: 10px;\n}\n\n.comment-add button {\n   margin-top: 10px;\n   padding: 1px 16px;\n   line-height: initial;\n   min-width: 64px;\n}\n@media (min-width: 768px) {\n   .is-desktop .comments-panel .comments-thread-container.active {\n      left: -36px;\n   }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
